import { Card, CardBody, CardHeader, Col, Label, Table } from "reactstrap";
import { H2, H3, H4 } from '../../../../AbstractElements';
import { useEffect, useState } from "react";
import { Controller, useForm } from 'react-hook-form';
import webservice from "../../../../Service/webservice";
import websocket_webservice from "../../../../Service/websocket_webservice";
import Select, { SingleValue } from "react-select";
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../../Service/crypto";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import ColumnChooser, { ColumnOption, isColVisible, visibleColCount } from "../../../../Components/ColumnChooser/ColumnChooser";
import { useColumnPreferences } from "../../../../hooks/useColumnPreferences";
import api from '../../../../api';

interface ClientOption {
    label: string;
    value: string;
    key: string;
}

interface IClientOption {
    label: string;
    value: string;
}
interface CompanyOption {
    label: string;
    value: string;
}

const Filetimetaken = () => {
    const { control } = useForm();
    const [adminoption, setClient] = useState<ClientOption[]>([]);
    const [recentOrdersBody, setrecentOrdersBody] = useState<[]>([]);
    // const [ClientName, setClientName] = useState<string>('');
    const [selectedClient, setSelectedClient] = useState<string>('All');
    const [selectedClientId, setSelectedClientId] = useState<string>('ALL');
    const [clientOptions, setClientOptions] = useState<IClientOption[]>([]);
    const dispatch = useDispatch();
    const { savedColumns, saveColumns } = useColumnPreferences('FiletimeListing');
    const columnOptions: ColumnOption[] = [
      { id: 'PatientName', label: 'Patient Name', locked: true },
      { id: 'Payer', label: 'Payer' },
      { id: 'UploadDate', label: 'Upload Date' },
      { id: 'CompletedDate', label: 'Completed Date' },
      { id: 'TemplateMappingTime', label: 'Template Mapping Time' },
    ];




    const calculateTAT = (uploadedDate: string): number => {
        const uploadDateObj = new Date(uploadedDate); // Convert uploaded_date to Date object
        const currentDate = new Date(); // Get the current date
        const differenceInTime = currentDate.getTime() - uploadDateObj.getTime(); // Difference in milliseconds
        const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24)); // Convert to days
        return differenceInDays;
    };


    const ViewAuditLog = async () => {
        const Username = localStorage.UserName;
        const Userid = localStorage.id;
        const Clientname = selectedClient;
        const Chartname = 'File Time'
        const Data = { Username, Clientname, Userid, Chartname };

        const key = await keyPromise
        const EncParams = await AesEncrypt(key,Data);
        const response = await api.fetch('api/Dashboard/auditlog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        return response;
    };

    useEffect(() => {
        let clientid: string | null;

        if (localStorage.UserType === 'MOS') {
            clientid = selectedClientId;
        } else if (localStorage.UserType === 'Vendor') {
            if (selectedClientId === 'ALL') {
                const allClient: any = clientOptions.filter(option => option.value !== 'ALL').map((option) => option.value);
                clientid = allClient;
            } else {
                clientid = selectedClientId;
            }
        } else {
            clientid = localStorage.ClientId;
        }

        const fetchData = async (clientid: any) => {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key,{ clientid, UserType: localStorage.UserType });
            const response = await api.fetch('api/Dashboard/Filetime', {
                method: 'POST',
                body: JSON.stringify({ EncParams }),
            }).then((response) => response.json());

            const TempData = response
            setrecentOrdersBody(TempData);
            return TempData;
        };

        fetchData(clientid);


        // const socket = new WebSocket(`${websocket_webservice}ws/Dashboardpatient/`);
        // // socket.onopen = () => console.log("WebSocket connected");
        // // socket.onclose = () => console.log("WebSocket closed");
        // // socket.onerror = (error) => console.error("WebSocket error:", error);

        // socket.onmessage = () => {
        //     fetchData(selectedClientId);
        // };

        // return () => {
        //     if (socket.readyState === 1) { // <-- This is important
        //         socket.close();
        //     }
        // }
    }, [dispatch, selectedClientId, selectedClient, clientOptions]);

    useEffect(() => {
        ViewAuditLog();
    }, []);

    const UserType = localStorage.UserType;
    const Id = localStorage.VendorId;
    const get_companyname = async () => {
        const key = await keyPromise
        const token = localStorage.getItem("token");
        // Prepare the request body based on UserType
        let bodyData = {};
        if (UserType === 'MOS') {
            bodyData = { UserType }; // Send UserType only
        } else if (UserType === 'Vendor') {
            bodyData = { UserType, VendorId: Id }; // Send both UserType and VendorId
        }

        // Make the fetch request
        const response = await api.fetch('api/Dashboard/getclient', {
            method: 'POST',
            body: JSON.stringify(bodyData), // Send the request body
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key,response);
        return TempData;
    };

    useEffect(() => {
        const fetchRoleId = async () => {
            try {
                const response = await get_companyname();
                const companyData = response.map((data: any) => ({
                    label: data.CompanyName,
                    value: data.id,
                }));

                // Sort the data alphabetically by label
                const sortedCompanyData = companyData.slice().sort((a: CompanyOption, b: CompanyOption) => a.label.localeCompare(b.label));
                // Add the 'All' option at the beginning of the list
                const allOption = { label: 'All', value: 'ALL' };
                const companyDataWithAll = [allOption, ...sortedCompanyData];

                // Set the client options state
                setClientOptions(companyDataWithAll);
            } catch (error) {
                console.error(error);
            }
        };

        // Fetch the initial data
        fetchRoleId();
        // WebSocket setup
        const socket = new WebSocket(`${websocket_webservice}ws/ClientDropdown/`);

        // socket.onopen = () => console.log('WebSocket connected');
        // socket.onclose = () => console.log('WebSocket closed');
        // socket.onerror = (error) => console.error('WebSocket error:', error);

        socket.onmessage = () => {
            // const change = JSON.parse(event.data);
            // console.log('WebSocket message received:', change);

            // Optionally, re-fetch the data to update the state when a WebSocket message is received
            fetchRoleId();
        };

        // Clean up the WebSocket connection when the component unmounts
        return () => {
            if (socket.readyState === 1) { // <-- This is important
                socket.close();
            }
        }
    }, []);

    const handleSelectClientChange = (selectedOption: SingleValue<IClientOption>) => {
        if (selectedOption) {
            if (localStorage.Usertype === 'Vendor' && selectedOption.value === 'ALL') {
                const allClient: any = clientOptions.filter(option => option.value !== 'ALL').map((option) => option.value);
                setSelectedClientId(allClient)
            } else {

                setSelectedClientId(selectedOption.value);
            }
            setSelectedClient(selectedOption.label);
            // template()
        } else {
            setSelectedClientId('ALL');
            setSelectedClient('');

        }
    }

    const formatTime = (seconds: any) => {
        if (seconds >= 60) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            return `${minutes}m ${remainingSeconds}s`;
        }
        return `${seconds}s`;
    };

    return (

        <Card className="invoice-card" style={{ height: '95%' }}>
            <CardHeader>
                <div className="header-top">
                    <H3>Time Frame</H3>
                    <div className="me-2">
                        <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={saveColumns} />
                    </div>

                    <Col xl={6}>
                        {(localStorage.UserType === 'MOS' || localStorage.UserType === 'Vendor') && (
                            <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                                <Label className="form-label" style={{ fontSize: "110%" }}>
                                    Select Client
                                </Label>
                                <Controller
                                    name="client"
                                    control={control} // control comes from react-hook-form
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isClearable
                                            options={clientOptions}
                                            classNamePrefix="select"
                                            placeholder="Client Names"
                                            className={classnames("form-control")}
                                            styles={{
                                                control: (styles) => ({
                                                    ...styles,
                                                    width: "100%",
                                                    height: '100%',
                                                    borderColor: "black",
                                                }),
                                                placeholder: (styles) => ({
                                                    ...styles,
                                                    textAlign: "center",
                                                }),
                                            }}
                                            value={selectedClient ? { value: selectedClientId, label: selectedClient } : null}
                                            onChange={(selectedOption) => {
                                                handleSelectClientChange(selectedOption as SingleValue<IClientOption>);
                                                field.onChange(selectedOption); // Update the field's value
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        )}
                    </Col>

                </div>
            </CardHeader>
            <CardBody className="transaction-card">
                <div className="table-responsive theme-scrollbar recent-wrapper">
                    <Table className="display order-wrapper" id="recent-order">
                        <thead>
                            <tr>
                                {isColVisible(columnOptions, savedColumns, 'PatientName') && <th>Patient Name</th>}
                                {isColVisible(columnOptions, savedColumns, 'Payer') && <th>Payer</th>}
                                {isColVisible(columnOptions, savedColumns, 'UploadDate') && <th>Upload Date</th>}
                                {isColVisible(columnOptions, savedColumns, 'CompletedDate') && <th>Completed Date</th>}
                                {isColVisible(columnOptions, savedColumns, 'TemplateMappingTime') && <th>Template Mapping Time</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {recentOrdersBody.length > 0 ? (
                                recentOrdersBody.map((data: any, index) => (
                                    <tr key={index}>
                                        {isColVisible(columnOptions, savedColumns, 'PatientName') && (
                                            <td>
                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-2">
                                                        <H4>{data.Patientname}</H4>
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                        {isColVisible(columnOptions, savedColumns, 'Payer') && <td>{data.Payer_name || 'N/A'}</td>}
                                        {isColVisible(columnOptions, savedColumns, 'UploadDate') && <td>{data.uploaded_date.split(" ")[0]}</td>}
                                        {isColVisible(columnOptions, savedColumns, 'CompletedDate') && <td>{data.Completed_date.split(" ")[0]}</td>}
                                        {/* <td>{data.xml_process_time ? formatTime(data.xml_process_time) : ''}</td> */}
                                        {isColVisible(columnOptions, savedColumns, 'TemplateMappingTime') && <td>{data.template_creation_running_time ? formatTime(data.template_creation_running_time) : ''}</td>}


                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={visibleColCount(columnOptions, savedColumns)} style={{ textAlign: 'center' }}>
                                        No records to display
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>

    );
};

export default Filetimetaken;
